<template>
    <fieldset id="type-filter">
              
        <label for="select-location"><strong>Type</strong></label>
        <select id="select-location" v-model="resource_type" @change="emitChange(resource_type)">
            <option value="">Alle</option>
            <option v-for="t in resource_types" :value="t.id">{{ t.name }}</option>
        </select>

    </fieldset>
</template>

<script>

    import axios from '../../../utils/Http.js'

    export default {
        data: function() {
            return {
                resource_type: '',
                resource_types: []
            }
        },
        methods: {
            init: function() {
                axios
                    .get('/booking/resourcetype/')
                    .then(res => {
                        this.resource_types = res.data
                    })
                    .catch(err => console.log(err))
            },
            emitChange: function(value) {
                this.$emit('filter', { 'resource_type': value })
            }
        },
        created: function() {
            this.init()
        }
    }
    
</script>